import { ICPlatformVersion } from '@retailer-platform/dashboard/access-control'
import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureToggle } from './featureToggles'

export const foodstormAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.FoodstormOmsView],
  warehouseFeatureToggles: [FeatureToggle.foodstorm],
  minICPlatformVersion: ICPlatformVersion.r2026_06_0,
}

export const foodstormModifyAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.FoodstormOmsModify],
  warehouseFeatureToggles: [FeatureToggle.foodstorm],
  minICPlatformVersion: ICPlatformVersion.r2026_06_0,
}
